module.exports = __webpack_public_path__ + "img/bing_2.f3896494.gif";